// Dependencies
require("webstrap/type");

// Copy images
require("!!asset!./img/arrow.svg");

// Styles
require("./entete-3-1.scss");

// Javascript
var $ = require("jquery");

// Scroll on click (arrow)
$('.entete-3-1').each(function () {

    var $elm = $(this),
        $btn = $('.entete-3-1__arrow-btn', $elm),
        $anchor = $($btn.attr('href'));

    $btn.on('click', function (e) {
        e.preventDefault();

        var offset = $anchor.offset(),
            menuHeight = 0,
            winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            scrollPos = 0,
            $menu = $('.js-menu-1-1-top');

        if ($menu.length > 0) {
            menuHeight = $menu.height();
        }

        if (offset.top < winHeight) {
            scrollPos = offset.top;
        } else {
            scrollPos = offset.top - menuHeight;
        }

        $('html,body').animate({ scrollTop: scrollPos }, 750);
        return false;
    });

});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/entete-3/view-1/index.js
// module id = 184
// module chunks = 0